import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var markIsConnectedAccountsDirty = mutatorAction('markIsConnectedAccountsDirty', function (isDirty) {
    var store = connectedAccountsStore();
    store.isConnectedAccountsDirty = isDirty;
});
//# sourceMappingURL=markIsConnectedAccountsDirty.js.map